"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactRouterDom = require("react-router-dom");
var _Services = require("../common_features/utility/Services");
var _StoreDetailsComponent = _interopRequireDefault(require("../components/StoreDetailsComponent"));
var _reactRedux = require("react-redux");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _helper = require("../common_features/utility/helper");
var _images = require("../common_features/assets/images");
var _event = require("../common_features/utility/event");
var _storesReducer = require("../common_features/redux/reducers/storesReducer");
var _alertReducer = require("../common_features/redux/reducers/alertReducer");
var _roleReducer = require("../common_features/redux/reducers/roleReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StoreDetails = () => {
  const baseFilter = {
    title: /*#__PURE__*/_react.default.createElement("span", {
      style: {
        textTransform: 'capitalize'
      },
      "data-testid": "all",
      "data-value": "Select"
    }, "Select"),
    key: 'title',
    value: 'Select'
  };
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const country = {};
  const bodySchema = [];
  const searchedData2 = null;
  const [sName, setSName] = (0, _react.useState)('');
  const [countries, setCountries] = (0, _react.useState)([]);
  const [zipcode, setZipcode] = (0, _react.useState)('');
  const [isZipCodeValid, setIsZipCodeValid] = (0, _react.useState)(false);
  const [address1, setAddress1] = (0, _react.useState)('');
  const [address2, setAddress2] = (0, _react.useState)('');
  const [city, setCity] = (0, _react.useState)('');
  const [state, setState] = (0, _react.useState)('');
  const [phoneNo, setPhoneNo] = (0, _react.useState)('');
  const [currentCountry, setCurrentCountry] = (0, _react.useState)({});
  const [count, setCount] = (0, _react.useState)(0);
  const [allSelect, setAllSelect] = (0, _react.useState)(false);
  const [disabled, setDisabled] = (0, _react.useState)(true);
  const [searchDisabled, setSearchDisabled] = (0, _react.useState)(true);
  const [allSelectModal, setAllSelectModal] = (0, _react.useState)(false);
  const [rowSelect, setRowSelect] = (0, _react.useState)([]);
  const [rowSelectModal, setRowSelectModal] = (0, _react.useState)([]);
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const [currentModalPage, setCurrentModalPage] = (0, _react.useState)(1);
  const pageSize = 5;
  const pageSizeModal = 5;
  const [query, setQuery] = (0, _react.useState)('');
  const [query2, setQuery2] = (0, _react.useState)('');
  const [selectedFilter, setSelectedFilter] = (0, _react.useState)(baseFilter);
  const [selectedFilter2, setSelectedFilter2] = (0, _react.useState)(baseFilter);
  const [isDataLoading, setIsDataLoading] = (0, _react.useState)(true);
  const [isDataLoading2, setIsDataLoading2] = (0, _react.useState)(true);
  const [bodySchemaModal, setBodySchemaModal] = (0, _react.useState)([]);
  const [bodySchemaAsignedUser, setBodySchemaAsignedUser] = (0, _react.useState)([]);
  const headerSchema = [{
    firstName: "First Name"
  }, {
    lastName: "Last Name"
  }, {
    email: "Email"
  }];
  const [userModal, setUserModal] = (0, _react.useState)(false);
  const [isEditable, setIsEditable] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [removeUserModal, setRemoveUserModal] = (0, _react.useState)(false);
  const [countModal, setCountModal] = (0, _react.useState)(0);
  const [searchedData, setSearchedData] = (0, _react.useState)(null);
  const [errorModal, setErrorModal] = (0, _react.useState)(false);
  const [errorModalData, setErrorModalData] = (0, _react.useState)({
    ErrorModalHeaderText: "User Does not Exist",
    ErrorModalDetailText: "User must have been deleted from the account. Please refesh the Page"
  });
  const [storeImage, setStoreImage] = (0, _react.useState)('');
  const [imageLoading, setImageLoading] = (0, _react.useState)(false);
  const [displayZoomImage, setDisplayZoomImage] = (0, _react.useState)(false);
  const dropdownList1 = [{
    title: 'Select',
    key: 'all',
    value: "Select"
  }, ...headerSchema].map(item => {
    return {
      title: /*#__PURE__*/_react.default.createElement("span", {
        style: {
          textTransform: 'capitalize'
        },
        "data-testid": Object.values(item)[0],
        "data-value": Object.keys(item)[0]
      }, Object.values(item)[0]),
      key: Object.keys(item)[0],
      value: Object.values(item)[0]
    };
  });
  const initialState = {
    sName: '',
    country: '',
    zipcode: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    phoneNo: ''
  };
  const [storeState, setStoreState] = (0, _react.useState)(initialState);
  const [edit, setEdit] = (0, _react.useState)(false);
  const {
    storeData
  } = (0, _reactRedux.useSelector)(state => state.stores);
  const setRowSelected = rowId => {
    if (allSelect) {
      setAllSelect(false);
      setRowSelect([rowId]);
      return;
    }
    const resultArr = rowSelect.filter(arrObj => arrObj !== rowId);
    if (resultArr.length === rowSelect.length) resultArr.push(rowId);
    setRowSelect(resultArr);
  };
  const setRowSelectedModal = rowId => {
    if (allSelectModal) {
      setAllSelectModal(false);
      setRowSelectModal([rowId]);
      return;
    }
    const resultArr = rowSelectModal.filter(arrObj => arrObj !== rowId);
    if (resultArr.length === rowSelectModal.length) resultArr.push(rowId);
    setRowSelectModal(resultArr);
  };
  const setAllSelected = flag => {
    setAllSelect(flag);
    if (flag) {
      setRowSelect(bodySchemaAsignedUser.map(rowData => rowData.id));
    } else {
      setRowSelect([]);
    }
  };
  const setAllSelectedModal = flag => {
    setAllSelectModal(flag);
    if (flag) {
      setRowSelectModal(bodySchemaModal.map(rowData => rowData.id));
    } else {
      setRowSelectModal([]);
    }
  };
  (0, _react.useEffect)(() => {
    var _storeData$data;
    if (storeData !== null && storeData !== void 0 && (_storeData$data = storeData.data) !== null && _storeData$data !== void 0 && _storeData$data.imageSubPath) {
      var _storeData$data2;
      setImageLoading(true);
      (0, _helper.fetchImage)(storeData === null || storeData === void 0 ? void 0 : (_storeData$data2 = storeData.data) === null || _storeData$data2 === void 0 ? void 0 : _storeData$data2.imageSubPath, setImageLoading, setStoreImage);
    }
  }, []);
  (0, _react.useEffect)(() => {
    if (selectedFilter.key === dropdownList1[0].key) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [selectedFilter]);
  (0, _react.useEffect)(() => {
    if (selectedFilter2.key === dropdownList1[0].key) {
      setSearchDisabled(true);
    } else {
      setSearchDisabled(false);
    }
  }, [selectedFilter2]);
  (0, _react.useEffect)(() => {
    const customCall = async () => {
      setIsLoading(true);
      let getCountries = [];
      const res = await (0, _Services.getCountryList)();
      if (res.success) {
        getCountries = res.data ? res.data.map(country => {
          return {
            code: country.code,
            title: country.name,
            key: country.name + country.code
          };
        }) : [];
        setCountries(getCountries);
      }
      await getStoreById(getCountries);
    };
    customCall();
    return {};
  }, []);
  (0, _react.useEffect)(() => {
    setIsEditable(userInfo.serachUserType === 6);
    setDataValuesToState(1);
    return () => {};
  }, [userInfo.userType]);
  (0, _react.useEffect)(() => {
    if ((selectedFilter.key === "all" || selectedFilter.key === "title") && query === "") setDataValuesToState(1);
    updateListOnWebSocketListen(1);
    return () => {};
  }, [query, selectedFilter]);
  (0, _react.useEffect)(() => {
    if ((selectedFilter2.key === "all" || selectedFilter2.key === "title") && query2 === "") updateListOnWebSocketListen(2);
    setDataValuesToState(2);
    return () => {};
  }, [query2, selectedFilter2]);
  const updateListOnWebSocketListen = async searchAccessType => {
    _event.eventEmitter.subscribe("socketOnMessage", data => {
      var _data$alert;
      if ((data === null || data === void 0 ? void 0 : (_data$alert = data.alert) === null || _data$alert === void 0 ? void 0 : _data$alert.alarmCode) === "GEN_DELETE_MANAGER" && "GEN_DELETE_TECHNICIAN") {
        setDataValuesToState(searchAccessType);
      }
    });
  };
  const setDataValuesToState = (storeAccessType, pageNo) => {
    if (!pageNo) {
      pageNo = storeAccessType === 1 ? currentPage : currentModalPage;
    }
    let params = {};
    if (storeAccessType === 1) {
      params = {
        query: selectedFilter.key !== "all" ? query : '',
        limit: pageSize,
        pageNo,
        attribute: selectedFilter.key,
        userType: userInfo.serachUserType,
        storeAccessType,
        storeId: storeData.storeId
      };
    } else {
      params = {
        query: selectedFilter2.key !== "all" ? query2 : '',
        limit: pageSizeModal,
        pageNo,
        attribute: selectedFilter2.key,
        userType: userInfo.serachUserType,
        storeAccessType,
        storeId: storeData.storeId
      };
    }
    if (storeAccessType === 1) {
      setIsDataLoading(true);
    } else {
      setIsDataLoading2(true);
    }
    (0, _Services.fetchStoreToUsers)(params).then(data => {
      if (data.data[userInfo.serachUserType]) {
        let rowBody = [];
        if (data.data[userInfo.serachUserType].rows.length) rowBody = data.data[userInfo.serachUserType].rows.map(row => {
          return {
            id: row.id,
            firstName: row.firstName,
            lastName: row.lastName,
            email: row.email,
            invitationStatus: row.invitationStatus,
            isActive: row.isActive
          };
        });
        if (storeAccessType === 2) {
          var _data$data$userInfo$s;
          setBodySchemaModal([...rowBody]);
          setCountModal((_data$data$userInfo$s = data.data[userInfo.serachUserType]) === null || _data$data$userInfo$s === void 0 ? void 0 : _data$data$userInfo$s.count);
        } else {
          var _data$data$userInfo$s2;
          setBodySchemaAsignedUser([...rowBody]);
          if (selectedFilter.key === 'all' || selectedFilter.key === 'title') {
            setSearchedData(null);
          } else {
            setSearchedData([...rowBody]);
          }
          setCount((_data$data$userInfo$s2 = data.data[userInfo.serachUserType]) === null || _data$data$userInfo$s2 === void 0 ? void 0 : _data$data$userInfo$s2.count);
        }
        setIsLoading(false);
      }
      setIsDataLoading(false);
      setIsDataLoading2(false);
    }).catch(() => {
      setIsDataLoading(false);
      setIsDataLoading2(false);
      setIsLoading(false);
    });
  };
  const handleSubmit = () => {
    setIsLoading(true);
    let requestType = "TagTechnician";
    if ([4].includes(userInfo.userType)) {
      requestType = "TagManager";
    }
    (0, _Services.TagTechnicianToStore)({
      storeIds: [storeData.storeId],
      userId: rowSelectModal,
      requestType
    }).then(res => {
      setUserModal(false);
      setRowSelect([]);
      setRowSelectModal([]);
      setAllSelectModal(false);
      setSelectedFilter2(baseFilter);
      setQuery2('');
      setCurrentModalPage(1);
      setDataValuesToState(1);
      if (!res.success) {
        setErrorModal(true);
        setErrorModalData({
          ErrorModalHeaderText: "User does not exists",
          ErrorModalDetailText: "The user has been removed from this account. Please refresh your page."
        });
      }
    });
  };
  const removeUserFromStore = () => {
    let requestType = "TagTechnician";
    if ([4].includes(userInfo.userType)) {
      requestType = "TagManager";
    }
    setIsLoading(true);
    (0, _Services.UnTagTechnicianToStore)({
      storeId: storeData.storeId,
      userIds: rowSelect,
      requestType
    }).then(res => {
      setRemoveUserModal(false);
      setRowSelectModal([]);
      setRowSelect([]);
      setAllSelected(false);
      setCurrentPage(1);
      setDataValuesToState(1, 1);
      if (!res.success) {
        setErrorModal(true);
        setErrorModalData({
          ErrorModalHeaderText: "User does not exists",
          ErrorModalDetailText: "The user has been removed from this account. Please refresh your page."
        });
      }
    });
  };
  function handleErrorModel(mode) {
    setIsLoading(false);
    setErrorModal(false);
    if ([4].includes(userInfo.userType)) {
      setDataValuesToState(1);
    } else {
      setDataValuesToState(2);
    }
    return true;
  }
  const checkformsInput = () => {
    return sName && zipcode && address1 && city && state && phoneNo.length > 5 || false;
  };
  const getStoreById = async getCountries => {
    setIsLoading(true);
    if (storeData.storeId) {
      (0, _Services.GetStore)(storeData.storeId).then(res => {
        setStoreState({
          ...storeState,
          sName: res.data.name,
          ...(0, _helper.parseAddress)(res.data.address),
          phoneNo: res.data.phoneNo,
          success: true
        });
        const {
          country,
          postalcode,
          address1,
          address2,
          city,
          state
        } = (0, _helper.parseAddress)(res.data.address);
        setSName(res.data.name);
        setZipcode(postalcode);
        setAddress1(address1);
        setAddress2(address2);
        setCity(city);
        setState(state);
        const currentCountry = getCountries.filter(cnt => cnt.code === country)[0];
        setCurrentCountry(currentCountry);
        setPhoneNo(res.data.phoneNo);
        setIsLoading(false);
      });
    } else {
      navigateToManageStore();
    }
    setIsLoading(false);
  };
  const navigateToManageStore = () => {
    navigate(_RoutePath.default.manageStore.useLink);
  };
  const updateCurrentStore = async () => {
    setIsLoading(true);
    let address = {
      "address1": "".concat(address1),
      "address2": "".concat(address2),
      "city": "".concat(city),
      "state": "".concat(state),
      "colony": "",
      "postalcode": "".concat(zipcode),
      "country": "".concat(currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.code)
    };
    const requestBody = {
      storeId: storeData.storeId,
      name: sName,
      address: JSON.stringify(address),
      phoneNo: phoneNo
    };
    const data = await (0, _Services.updateStore)(requestBody);
    if (data.success) {
      setEdit(false);
      setIsLoading(false);
    }
  };
  const onZipcodeBlur = e => {
    setIsLoading(true);
    (0, _Services.GetCityState)({
      zipcode: e.target.value,
      country: currentCountry.code
    }).then(data => {
      setIsLoading(false);
      if (data.error) {
        setIsZipCodeValid(true);
      } else {
        setIsZipCodeValid(false);
        const city = data.response.results[0].address_components[1].long_name;
        const state = data.response.results[0].address_components.filter(element => {
          return element.types.includes("administrative_area_level_1");
        })[0].short_name;
        setCity(city);
        setState(state);
      }
    });
  };
  const onChangeHandler = async function (e, name) {
    if (!e.target.onblur) {
      e.target.onblur = onZipcodeBlur;
    }
  };
  const handleRemoveUserModal = flag => {
    setRemoveUserModal(flag);
  };
  const handleModalPageChange = pageNum => {
    setCurrentModalPage(pageNum);
    setDataValuesToState(2, pageNum);
  };
  const handlePageChange = pageNum => {
    setCurrentPage(pageNum);
    setDataValuesToState(1, pageNum);
  };
  const checkClearBtnListener = () => {
    console.log(document.querySelector('.modal-with-table .ant-input-clear-icon-has-suffix'));
    if (document.querySelector('.ant-input-clear-icon-has-suffix')) {
      document.querySelector('.ant-input-clear-icon-has-suffix').onclick = () => {
        setQuery('');
        setCurrentPage(1);
        setDataValuesToState(1);
      };
    }
    if (document.querySelector('.modal-with-table .ant-input-clear-icon-has-suffix')) {
      document.querySelector('.modal-with-table .ant-input-clear-icon-has-suffix').onclick = () => {
        setQuery2('');
        setCurrentModalPage(1);
        setDataValuesToState(2);
      };
    }
  };
  const handleOnKeyPress = (e, type) => {
    if (e.key === "Enter") {
      setDataValuesToState(type);
    }
  };
  const structureAddress = str => {
    return (0, _helper.isJSON)(str) ? (0, _helper.bindAddress)(JSON.parse(str)) : str;
  };
  const handleSystemBtn = () => {
    var _storeData$data3;
    sessionStorage.setItem("Dispatcher_Web_Mobile_View", 1);
    dispatch((0, _roleReducer.setUserScreenPref)("Dispatcher_Web_Mobile_View"));
    dispatch((0, _storesReducer.selectStore)({
      ...storeData.data,
      address: structureAddress((_storeData$data3 = storeData.data) === null || _storeData$data3 === void 0 ? void 0 : _storeData$data3.address)
    }));
    (0, _Services.getAlerts)(storeData.storeId).then(res => {
      if (res.success) {
        const payload = {
          storeId: storeData.storeId,
          data: res.data
        };
        dispatch((0, _alertReducer.alertData)(payload));
      }
    });
    if (userInfo.userType === 4) {
      navigate(_RoutePath.default.storeDashboard.useLink);
    } else {
      navigate(_RoutePath.default.techDispatcher.useLink);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_StoreDetailsComponent.default, {
    sName: sName,
    country: country,
    zipcode: zipcode,
    isZipCodeValid: isZipCodeValid,
    address1: address1,
    address2: address2,
    city: city,
    state: state,
    phoneNo: phoneNo,
    setSName: e => {
      setSName(e.target.value);
    },
    setCountry: e => {
      setCurrentCountry(e);
    },
    setZipcode: e => {
      setZipcode(e.target.value);
      onChangeHandler(e, 'zipcode');
    },
    setIsZipCodeValid: setIsZipCodeValid,
    countries: countries,
    setAddress1: e => {
      setAddress1(e.target.value);
    },
    setAddress2: e => {
      setAddress2(e.target.value);
    },
    setCity: e => {
      setCity(e.target.value);
    },
    setState: e => {
      setState(e.target.value);
    },
    setPhoneNo: setPhoneNo,
    navigate: navigateToManageStore,
    title: currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.title,
    isErrorFree: true,
    onChangeHandler: onChangeHandler,
    isFormValid: checkformsInput,
    storeState: storeState,
    setStoreState: setStoreState,
    edit: edit,
    setEdit: setEdit,
    updateCurrentStore: updateCurrentStore,
    count: count,
    rowSelect: rowSelect,
    rowSelectModal: rowSelectModal,
    setAllSelected: setAllSelected,
    setAllSelectedModal: setAllSelectedModal,
    headerSchema: headerSchema,
    bodySchema: bodySchema,
    bodySchemaModal: bodySchemaModal,
    allSelect: allSelect,
    allSelectModal: allSelectModal,
    setRowSelected: setRowSelected,
    setRowSelectedModal: setRowSelectedModal,
    setSelectedFilter: setSelectedFilter,
    setSelectedFilter2: setSelectedFilter2,
    selectedFilter: selectedFilter,
    selectedFilter2: selectedFilter2,
    bodySchemaAsignedUser: bodySchemaAsignedUser,
    setDataValuesToState: setDataValuesToState,
    isDataLoading: isDataLoading,
    isDataLoading2: isDataLoading2,
    serachUserType: userInfo.serachUserType,
    query: query,
    query2: query2,
    setQuery: e => {
      setQuery(e.target.value);
      checkClearBtnListener();
    },
    setQuery2: e => {
      setQuery2(e.target.value);
      checkClearBtnListener();
    },
    setSearch: e => {
      setDataValuesToState(1);
    },
    setSearch2: e => {
      setDataValuesToState(2);
    },
    userModal: userModal,
    setUserModal: () => setUserModal(false),
    handleModal: () => {
      setUserModal(true);
      setDataValuesToState(2);
    },
    handleSubmit: handleSubmit,
    isEditable: isEditable,
    isLoading: isLoading || imageLoading,
    removeUserModal: removeUserModal,
    modalHeaderText: "Are you sure you want to remove ".concat(rowSelect.length, " ").concat(rowSelect.length > 1 ? "".concat(userInfo.userType === 4 ? "Employees" : "Technicians") : "".concat(userInfo.userType === 4 ? "Employee" : "Technician"), "?"),
    ModalVarient: "remove-user-modal",
    modalDetailText: "This action cannot be undone.",
    positiveActionButtonTitle: "Remove ".concat(rowSelect.length, " ").concat(rowSelect.length > 1 ? "".concat(userInfo.userType === 4 ? "Employees" : "Technicians") : "".concat(userInfo.userType === 4 ? "Employee" : "Technician")),
    negativeButtonActionTitle: "Cancel",
    handleResendInviteModal: removeUserFromStore,
    handleSetReInviteCancelModal: () => handleRemoveUserModal(false),
    handleRemoveUserModal: () => handleRemoveUserModal(true),
    currentModalPage: currentModalPage,
    countModal: countModal,
    pageSizeModal: pageSizeModal,
    pageSize: pageSize,
    handleModalPageChange: handleModalPageChange,
    searchedData: searchedData,
    searchedData2: searchedData2,
    currentPage: currentPage,
    handlePageChange: handlePageChange,
    handleOnKeyPress1: e => handleOnKeyPress(e, 1),
    handleOnKeyPress2: e => handleOnKeyPress(e, 2),
    dropdownList1: dropdownList1,
    userType: userInfo.userType,
    errorModal: errorModal,
    ErrorModalVariant: "remove-user-modal",
    ErrorModalHeaderText: errorModalData.ErrorModalHeaderText,
    ErrorModalDetailText: errorModalData.ErrorModalDetailText,
    customIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: _images.warningSvg.default
    }),
    positiveActionErrorButtonTitle: "Continue",
    handleErrorModal: () => handleErrorModel(false),
    disabled: disabled,
    searchDisabled: searchDisabled,
    storeImage: storeImage ? storeImage : _images.noImg.default,
    storeImageStyle: storeImage ? {
      width: "100%",
      height: "100%",
      borderRadius: 10
    } : {
      margin: "0px auto",
      height: "65px",
      width: "100%"
    },
    zoomImageAction: () => {
      setDisplayZoomImage(true);
    },
    displayZoomImage: displayZoomImage,
    crossIconAction: () => {
      setDisplayZoomImage(false);
    },
    handleSystemBtn: handleSystemBtn,
    viewHeaderText: "View"
  }))));
};
var _default = exports.default = StoreDetails;